<template>
  <div class="buyerIndex">
    <!--  -->
    <div class="searchPart">
      <div class="search_box">
        <!-- <div>
          <md-icon name="search" size="sm"></md-icon>
          <input type="text" v-model="searchWord" placeholder="搜索买家姓名" @change="getValue" />
          <span v-if="searchWord" @click="clearSearchWord">
            <i data-v-37585f17 class="iconfont icon-guanbi" style="color:#666;"></i>
          </span>
        </div>-->

        <!-- 搜索 -->
        <div class="input_s br4">
          <div class="list_search br4">
            <input type="text" v-model="searchWord" @input="getValue()" placeholder="搜索买家姓名" />
            <span class="icon_search">
              <i class="iconfont icon-sousuo" style="color:#888"></i>
            </span>
            <span class="icon_close" v-if="searchWord" @click="searchWord = '';getValue()">
              <i class="iconfont icon-guanbi" style="color:#888"></i>
            </span>
          </div>
        </div>

        <div class="toAddBuyer" @click="ab_popShow=true">新增买家</div>
        <!-- 新增买家 -->
        <AddBuyer :pop_show="ab_popShow" @cancel="ab_popShow = false" @finish="upload" />
      </div>
      <div class="total_amount" v-if="creditingCount">
        <span>赊欠单数：{{creditingCount*1}}单</span>
        <span v-if="Number(creditNeedRepaymentAmount)>0">
          未还总额：
          <span style="color:#f79a07">{{creditNeedRepaymentAmount*1}}</span>元
        </span>
      </div>
      <div class="total_num">
        共
        <span>{{list.length}}</span>个买家
      </div>
    </div>
    <!--1  -->
    <div class="listPart">
      <div class="listPartContent">
        <!-- 列表部分 -->
        <div class="left">
          <md-scroll-view
            ref="b_c_scrollView"
            :auto-reflow="true"
            :bouncing="true"
            :scrolling-x="false"
          >
            <!-- <md-scroll-view-refresh roller-color="#31B158" slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }" :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive" ></md-scroll-view-refresh> -->
            <div class="view_items">
              <div class="scroll-view-list br4" v-for="(item,index) in list" :key="index">
                <div class="list_l" @click="goBuyerDetail(item.id)">
                  <div class="item1">
                    <div>{{item.name}}</div>
                    <div v-if="item.credit_need_repayment_amount">
                      <span>欠款:</span>
                      <span>￥</span>
                      <span>{{item.credit_need_repayment_amount*1 || 0}}</span>
                    </div>
                  </div>
                  <div class="item2">
                    <div>
                      <div v-if="item.id!=1">{{item.crediting_count || 0}}单</div>
                      <div v-if="item.id==1">-</div>
                      <div>赊欠单数</div>
                    </div>
                  </div>
                  <div class="item3">
                    <div v-if="item.first_crediting_time<=0">-</div>
                    <div v-else>{{item.first_crediting_time | toDate}}</div>
                    <div>最早赊欠时间</div>
                  </div>
                </div>
                <div class="list_r">
                  <div class="s_line"></div>
                  <div class="item4" @click="lookPayHistory(item.id)">
                    <span v-if="item.id==1">-</span>
                    <span v-else>还款记录</span>
                    <md-icon
                      name="arrow-right"
                      size="xs"
                      v-if="item.id!=1"
                      style="margin-top:0.04rem"
                    ></md-icon>
                  </div>
                  <div class="s_line"></div>
                  <div class="item5" @click="goBuyerDetail(item.id)">
                    <span v-if="item.id==1">去查看</span>
                    <span v-else>去还款</span>
                    <md-icon name="arrow-right" size="xs" style="color:#31b158;margin-top:0.04rem"></md-icon>
                  </div>
                </div>
              </div>
            </div>
            <md-scroll-view-more
              slot="more"
              :is-finished="isFinished"
              :finished-text="list.length>0?'全部已加载':'暂无数据'"
            ></md-scroll-view-more>
          </md-scroll-view>
        </div>
        <!-- 检索部分 -->
        <div class="right">
          <div class="total brt4" :class="{noActive:nowIndex!=-1}" @click="getAll()">全部</div>
          <div class="nameList">
            <div
              v-for="(item,i) in firstNameList"
              :key="i"
              :class="{ active: i != nowIndex }"
              @click="getTabs(item,i)"
            >{{item}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 还款记录 -->
    <PaymentHistory
      ref="paymentHistory"
      :pop_show="showHistory"
      :buyerId="buyerId"
      @cancel="showHistory=false,buyerId=''"
    />
  </div>
</template>

<script>
import AddBuyer from "../open/addBuyer";
import PaymentHistory from "./paymentHistory";
import { buyer_list, buyer_firstNameList } from "@/api/work/buyer";
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
export default {
  name: "buyerIndex",
  components: {
    AddBuyer,
    PaymentHistory,
  },
  data() {
    return {
      searchWord: "", //搜索关键字
      isFinished: false,
      ab_popShow: false, //控制弹框
      list: [], //买家列表
      firstNameList: [], //首字母列表
      showHistory: false,
      creditingCount: 0, //赊欠总单数
      creditAmount: 0, //赊欠总金额
      creditNeedRepaymentAmount: 0, //未还总金额
      tabName: "",
      nowIndex: -1,
      buyerId: "",
    };
  },
  
  beforeRouteEnter (to, from, next) {
    next(vm=>{
      vm.getBuyerList();
    })
  },
  created() {
    this.getBuyerFirstName();
  },
  mounted() {},
  methods: {
    // 下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      setTimeout(() => {
        this.$refs.scrollView.finishLoadMore();
      }, 1000);
    },
    //查看还款记录
    lookPayHistory(id) {
      // this.showHistory=true
      // this.buyerId=id
      if (id != 1) {
        this.$refs.paymentHistory.showPop(id);
      }
    },
    //去买家详情
    goBuyerDetail(id) {
      this.$router.push({
        path: "/buyer/detail",
        query: {
          buyerId: id,
        },
      });
    },
    //获取买家列表
    getBuyerList() {
      let obj = {
        status: "",
        name: this.searchWord,
        name_first: this.tabName,
      };
      this.isFinished = false;
      buyer_list(obj).then((res) => {
        if (res.code == 200) {
          this.creditingCount = res.data.creditingCount||0;
          this.creditAmount = res.data.creditAmount||0;
          this.creditNeedRepaymentAmount = res.data.creditNeedRepaymentAmount||0;
          this.list = res.data.list;
          this.isFinished = true;
        }
      });
    },
    //获取买家首字列表
    getBuyerFirstName() {
      buyer_firstNameList().then((res) => {
        if (res.code == 200) {
          this.firstNameList = res.data.nameFirstList;
        }
      });
    },
    upload() {
      this.getBuyerFirstName();
      this.getBuyerList();
    },
    //点击首字母筛选
    getTabs(name, i) {
      this.nowIndex = i;
      this.tabName = name;
      this.getBuyerList();
    },
    //点击全部
    getAll() {
      this.nowIndex = -1;
      this.tabName = "";
      this.getBuyerList();
    },
    getValue() {
      this.getBuyerList();
    },
    clearSearchWord() {
      this.searchWord = "";
      this.getBuyerList();
    },
  },
};
</script>

<style lang="less" scoped>
.buyerIndex {
  position: relative;
  height: 100%;
  background: #e1e1e1;
  overflow: hidden;
  .searchPart {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 0.8rem;
    padding: 0 0.1rem;
    color: #404040;
    font-size: 0.24rem;
    background: #fff;
    box-shadow: 0 0.02rem 0.04rem 0.02rem rgba(221, 221, 221, 0.5);
    position: relative;
    z-index: 2;
    .total_amount {
      flex: 1;
      text-align: right;
      font-size: 0.24rem;
      > span:nth-of-type(1) {
        margin-right: 0.4rem;
      }
    }

    .search_box {
      display: flex;
      align-items: center;
      height: 0.6rem;
      .input_s {
        width: 2.4rem;
        overflow: hidden;
        position: relative;
        margin-left: 0.01rem;
        .list_search {
          width: 100%;
          height: 0.5rem;
          box-sizing: border-box;
          padding: 0;
          position: relative;
          input {
            line-height: 0.5rem;
            font-size: 0.2rem;
            border: none;
            outline: none;
            background-color: #e6e6e6;
            width: 100%;
            text-indent: 0.4rem;
          }
          span {
            top: 0.14rem;
          }
          span.icon_search {
            left: 0.12rem;
          }
        }
      }
      .toAddBuyer {
        width: 1.3rem;
        height: 0.5rem;
        background: #31b158;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 0.24rem;
        border-radius: 0.04rem;
        margin-left: 0.1rem;
      }
    }
    .total_num {
      width: 2.36rem;
      text-align: right;
      font-size: 0.24rem;
      margin-right: 0.1rem;
      span {
        color: #31b158;
      }
    }
  }
  .listPart {
    padding: 0 0.1rem;
    height: calc(100% - 0.8rem);
    .listPartContent {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      .left {
        width: 12.18rem;
        height: 100%;
        overflow: auto;
        .scroll-view-list {
          padding: 0.12rem 0rem 0.12rem 0.32rem;
          display: flex;
          background: #fff;
          margin-right: 0.1rem;
          height: 0.88rem;
          margin-top: 0.1rem;
          .list_l {
            display: flex;
            .item1 {
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: 1.72rem;
              margin-right: 2.2rem;
              div:nth-of-type(1) {
                color: #404040;
                font-size: 0.24rem;
                line-height: 0.34rem;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
              div:nth-of-type(2) {
                line-height: 0.28rem;
                span:nth-of-type(1) {
                  color: #999999;
                  font-size: 0.2rem;
                  margin-right: 0.12rem;
                }
                span:nth-of-type(2) {
                  color: #f79a07;
                  font-size: 0.16rem;
                }
                span:nth-of-type(3) {
                  color: #f79a07;
                  font-size: 0.2rem;
                }
              }
            }
            .item2 {
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: 1rem;
              margin-right: 0.8rem;
              div:nth-of-type(1) {
                color: #404040;
                font-size: 0.24rem;
                text-align: center;
                line-height: 0.34rem;
              }
              div:nth-of-type(2) {
                line-height: 0.28rem;
                color: #999999;
                text-align: center;
                font-size: 0.2rem;
              }
            }
            .item3 {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              width: 1.6rem;
              margin-right: 0.8rem;
              div:nth-of-type(1) {
                color: #404040;
                font-size: 0.24rem;
                line-height: 0.34rem;
              }
              div:nth-of-type(2) {
                line-height: 0.28rem;
                color: #999;
                font-size: 0.2rem;
              }
            }
          }
          .list_r {
            display: flex;
            align-items: center;
            .s_line {
              width: 0.01rem;
              height: 0.5rem;
              background: #c1c1c1;
            }
            .item4 {
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              width: 1.84rem;
              padding-right: 0.4rem;
              padding-left: 0.28rem;
              color: #999;
              font-size: 0.24rem;
            }
            .item5 {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding: 0.3rem 0;
              padding-right: 0.4rem;
              padding-left: 0.3rem;
              color: #404040;
              font-size: 0.24rem;
              span {
                color: #31b158;
                margin-left: 0.1rem;
              }
            }
          }
        }
      }
      .right {
        width: 0.6rem;
        height: 100%;
        padding-top: 0.1rem;
        .total {
          background: rgba(49, 177, 88, 0.3);
          font-size: 0.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 0.54rem;
          width: 100%;
          text-align: center;
          border-bottom: 0.01rem solid #e1f3e7;
          color: #31b158;
        }
        .noActive {
          color: #404040;
          background: #fff;
        }
        .nameList {
          height: calc(100% - 0.54rem);
          background: #fff;
          overflow-y: scroll;
          div {
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 0.54rem;
            width: 100%;
            text-align: center;
            border-bottom: 0.01rem solid #e1f3e7;
            color: #31b158;
            background: rgba(49, 177, 88, 0.3);
            font-size: 0.2rem;
          }
          .active {
            color: #404040;
            background: #fff;
          }
        }
      }
    }
  }
}
.md-example-popup-center {
  background: #fff;
  padding: 0.5rem;
}
</style>